export const flowMessageZH = {
  flowMessage1: '活动消息',
  flowMessage2: '学术公告',
  flowMessage3: '系统通知',
  flowMessage4: '互动消息',
  flowMessage5: '暂无消息',
  flowMessage6: '查看>>',
  flowMessage7: '确定',
  flowMessage8: '我的帖子：',
  flowMessage9: '视频',
  flowMessage10: '图片',
  flowMessage11: '我的评论：',
  flowMessage12: '公告列表',
  flowMessage13: '还有',
  flowMessage14: '篇未读公告。',
  flowMessage15: '此内容已被删除',
  flowMessage16: '返回',
  flowMessage17: '没有更多数据',
  flowMessage18: '请前往网页端查看',
  flowMessage19: '请用电脑访问www.webloom.cn进行查看',
  flowMessage20: '暂无更多数据了哦~',
  flowMessage21: '没有更多数据',
  flowMessage22: '请前往网页端查看',
  flowMessage23: '前往查看 >> ',
  flowMessage24: '确 定',
  flowMessage25: '距离截止时间还有',
  flowMessage26: '任务。',
  flowMessage27: 'alert',
  flowMessage28: 'content',
  flowMessage29: 'pushTimeStr',
  flowMessage30: '取 消',
  flowMessage31: '以上为跳转链接，请复制并去浏览器中打开',
  flowMessage32: '复制成功！',
  flowMessage33: '提示',
  flowMessage34: '确认',
  flowMessage35: 'publishDateStr',
  flowMessage36: 'tagName',
  flowMessage37: 'publishTimeDesc',
  flowMessage38: 'tags',
  flowMessage39: 'publishTimeStr',
  flowMessage40: 'publishTime',
  flowMessage41: 'commentTimeStr'
}

export const flowMessageEN = {
  flowMessage1: 'Activity Message',
  flowMessage2: 'Academic Bulletin',
  flowMessage3: 'System Notifications',
  flowMessage4: 'Interactive Messages',
  flowMessage5: 'No news yet',
  flowMessage6: 'Check out >>',
  flowMessage7: 'confirm',
  flowMessage8: 'My posts',
  flowMessage9: 'Video',
  flowMessage10: 'Image',
  flowMessage11: 'My comments',
  flowMessage12: 'Announcement List',
  flowMessage13: 'There are ',
  flowMessage14: ' unread announcements.',
  flowMessage15: 'This content has been removed',
  flowMessage16: 'back',
  flowMessage17: 'No more data',
  flowMessage18: 'Please visit the web page',
  flowMessage19: 'Please visit www.webloom.cn on your computer to check',
  flowMessage20: 'No more data yet ~',
  flowMessage21: 'No more data',
  flowMessage22: 'Please visit the web page',
  flowMessage23: ' go to check >> ',
  flowMessage24: 'confirm',
  flowMessage25: ' day(s) to deadline',
  flowMessage26: 'tasks.',
  flowMessage27: 'alertEn',
  flowMessage28: 'contentEn',
  flowMessage29: 'pushTimeStrEn',
  flowMessage30: 'Cancel',
  flowMessage31: 'The above is a jump link, please copy and go to your browser to open it!',
  flowMessage32: 'Copy Success!',
  flowMessage33: 'TIps',
  flowMessage34: 'Got it',
  flowMessage35: 'publishDateStrEn',
  flowMessage36: 'tagNameEn',
  flowMessage37: 'publishTimeDescEn',
  flowMessage38: 'tagsEn',
  flowMessage39: 'publishTimeStrEn',
  flowMessage40: 'publishTimeEn',
  flowMessage41: 'commentTimeStrEn'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/message.js